import styled from "styled-components/macro";
import { media } from "../../../utils";

export const StyledCardHeader = styled.div``;

export const StyledCardBody = styled.div``;

export const StyledCardFooter = styled.div``;

export const WidgetStyle = styled.div(({ theme, backgroundLevel }) => ({
  width: "100%",
  maxWidth: "344px",
  borderRadius: "16px",
  boxShadow: "0px 8px 12px 0px #2d292629, 0px -2px 2px 0px #2d29260d",
  padding: "16px",
  marginBottom: "16px",
  backgroundColor: backgroundLevel
    ? theme.color.neutral[backgroundLevel]
    : null,

  [`& ${StyledCardHeader}`]: {
    borderBottom: `1px solid ${theme.color.neutral["05"]}`,
    paddingBottom: "8px",
  },

  [`& ${StyledCardBody}`]: {
    paddingTop: "8px",
    color: theme.color.brandPrimary.light,
  },
}));

export const WidgetCardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 16px auto;
  ${media.md()} {
    margin: 16px -16px;
    ${WidgetStyle} {
      margin: 16px;
    }
  }
`;

export const StyledCard = styled.div`
  & ${StyledCardHeader}, & ${StyledCardBody}, & ${StyledCardHeader} {
    width: 100%;
  }
`;

export default StyledCard;
